import { QueryFunctionContext } from '@tanstack/react-query';

import { ForcedRankingsService } from 'src/services/ForcedRankingsService';

export const QUERY_KEY = 'forced_ranking_strategies';

export const queryForcedRankingStrategies = (
    context: QueryFunctionContext<App.ForcedRankings.QueryKey, number>,
): Promise<string[]> => {
    const { queryKey } = context;
    const [, accessToken, search] = queryKey;
    const { offset, limit } = search;

    return ForcedRankingsService.getForcedRankingStrategies(
        accessToken,
        search,
        offset,
        limit,
    );
};
